<template>
  <div id="App">
      <div id="products-right">
        <div class="index-zcfg-right-div-top">

          <img  v-if="user.headimgurl " :src="user.headimgurl"  />
          <img src="../../../static/img/indextj3.jpg" alt=""  v-else  />
          <span v-if="user.username">{{user.username}}</span>
          <span v-else>未登录</span>
        </div>
        <div class="clear"></div>
          <ul class="index-touxiang-ul index-touxiang-ul1">
            <li>发布文章</li>
            <li>回答</li>
            <li>我的收藏</li>
          </ul>
          <ul class="index-touxiang-ul index-touxiang-ul2">
            <li><router-link :to="{path:'/Forum',query: {memberindex: 4}}">{{user.wzcount}}</router-link> </li>
            <li><router-link :to="{path:'/Forum',query: {memberindex: 4}}">{{user.hdcount}}</router-link></li>
            <li><router-link :to="{path:'/Forum',query: {memberindex: 4}}">{{user.sccount}}</router-link></li>
          </ul>
      </div>
      <div id="products-right" class="top-top">
           <p class="products-right-title">公告</p>
           <ul class="products-right-ul">
             <li class="ov1" v-for="(item, index) in left" :key="item.id">
               <router-link :to="{path:'/Aboutdy',query: {id: item.id,cid:item.cid}}">
                   {{item.title}}
              </router-link>
             </li>
           </ul>
       </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        user:{
          headimgurl:''
        },
        left:[],
      }
    },
   mounted () {
     console.log(this.user.headimgurl)
     this.recordapi();
   },
   methods:{
     recordapi(){
         var that = this;
         var userid = that.$cookieStore.getCookie('userid');
         console.log(userid);
         that.$api.post("/Products/JobsRightUser",{'userid':userid}).then(res => {
           console.log(res);
           if(res.user){
             that.user= res.user;
           }

           that.left= res.left;
         });
     },
   }

   }
</script>



// WEBPACK FOOTER //
// src/components/public/userRight.vue